import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Image, Header, Icon } from "semantic-ui-react";
import { getLabel } from "../../constants/Strings";
import { createInvestor } from "../../redux/actions/user";

import Container from "../../components/Container/Container";

//Components
import PasswordInput from "../../components/PasswordInput/PasswordInput";
import Input from "../../components/Input/Input";

import styles from "./CreateInvestorScreen.module.css";

class CreateInvestorScreen extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      nom: "",
      prenom: "",
      phone: "509",
      password: "",
      percentage: "",
      errorMessage: "",
      successMessage: "",
    };

    window.scrollTo(0, 0);
  }

  handleCreate = async () => {
    const { nom, prenom, phone, password, percentage } = this.state;
    this.setState({ errorMessage: "", successMessage: "" });

    // Validate inputs
    if (!nom || !prenom || !password || !percentage || !phone) {
      this.setState({ errorMessage: "Veuillez remplir tous les champs." });
      return;
    }

    if (phone.length !== 11) {
      this.setState({ errorMessage: "Le numéro de téléphone doit avoir 11 caractères (ex: 509xxxxxxxx)." });
      return;
    }

    const { dispatch } = this.props;
    const ok = await dispatch(
      createInvestor(nom, prenom, phone, password, percentage)
    );

    if (ok) {
      // Clear form on success
      this.setState({
        nom: "",
        prenom: "",
        phone: "509",
        password: "",
        percentage: "",
        errorMessage: "",
        successMessage: "Investisseur créé avec succès !"
      });

      // Hide success message after a few seconds
      setTimeout(() => {
        this.setState({ successMessage: "" });
      }, 5000);
    } else {
      this.setState({ errorMessage: "Erreur lors de la création de l'investisseur." });
    }
  };

  handleInputOnChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      if (!value.startsWith("509")) {
        return;
      }
      if (value.length <= 11) {
        this.setState({ phone: value });
      }
    } else {
      this.setState({ [name]: value });
    }
  };

  render() {
    const { nom, prenom, phone, password, percentage, errorMessage, successMessage } = this.state;

    return (
      <Container title={getLabel("CreateInvestor")}>
        <div className={styles.container}>
          <div className={styles.logoContainer}>
            <Image src={"/logo3_1.png"} className={styles.logo} />
            <Header as="h1" textAlign="center" className={styles.title}>
              {getLabel("CreateInvestor")}
            </Header>
            <p className={styles.subtitle}>Ajoutez un nouvel associé à votre réseau</p>
          </div>

          <div className={styles.inputsContainer}>
            <Input
              name={"nom"}
              value={nom}
              placeholder={getLabel("LastName")}
              type={"text"}
              onChange={this.handleInputOnChange}
              icon="user"
            />
            <Input
              name={"prenom"}
              value={prenom}
              placeholder={getLabel("FirstName")}
              onChange={this.handleInputOnChange}
              icon="user outline"
            />
            <Input
              name={"phone"}
              type={"text"}
              value={phone}
              placeholder={getLabel("Phone")}
              onChange={this.handleInputOnChange}
              icon="phone"
            />

            <Input
              name={"percentage"}
              value={percentage}
              placeholder={getLabel("Percent") + " (%)"}
              type={"number"}
              onChange={this.handleInputOnChange}
              icon="percent"
            />

            <PasswordInput
              name={"password"}
              value={password}
              placeholder={getLabel("Password")}
              onChange={this.handleInputOnChange}
            />

            {errorMessage && <div className={styles.errorMessage}><Icon name='warning circle' /> {errorMessage}</div>}
            {successMessage && <div className={styles.successMessage}><Icon name='check circle' /> {successMessage}</div>}

            <Button
              fluid
              className={styles.button}
              onClick={this.handleCreate}
              loading={this.props.user.loading}
            >
              {getLabel("Save")}
            </Button>
          </div>
        </div>
      </Container>
    );
  }
}

function mapStateToProps({ user }) {
  return { user };
}

export default withRouter(connect(mapStateToProps)(CreateInvestorScreen));
